import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import AccountForm from '@/modules/Account/components/AccountForm.vue'
import { deleteAccount } from '@/modules/Account/gql/account.gql'

@Component({
  components: {
    AppDialog,
    AccountForm
  }
})
export default class AccountDialog extends Vue {
  targetAccount: Account | null = null

  accountDialog = {
    actionType: 'new',
    show: false,
    title: 'New Account',
    disable: false
  }

  deleteAcctDialog = {
    show: false,
    title: 'Delete Account',
    text: ''
  }

  showAcctEditDialog (e: Event, targetAccount?: Account) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Account'
    if (targetAccount) {
      this.targetAccount = targetAccount
      actionType = 'edit'
      title = 'Edit Account'
    }
    this.accountDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideAcctEditDialog () {
    this.targetAccount = null
    this.accountDialog = {
      actionType: 'new',
      show: false,
      title: 'New Account',
      disable: false
    }
  }

  async deleteAccount (e: Event, account: Account) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccount = account
    this.deleteAcctDialog.show = true
  }

  async deleteAcctPost () {
    if (!this.targetAccount) {
      return
    }
    const { id } = this.targetAccount
    this.deleteAcctDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAccount,
        variables: {
          accountId: Number(id)
        }
      })

      const res = result.data.deleteAccount
      if (res) {
        showNotification({
          msg: 'Delete account successfully',
          type: SnackType.Success
        })
        this.targetAccount = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
